export const GET_DIRECTORS_REQUEST = "GET_DIRECTORS_REQUEST";
export const GET_DIRECTORS_RESPONSE = "GET_DIRECTORS_RESPONSE";
export const DELETE_DIRECTORS_REQUEST = "DELETE_DIRECTORS_REQUEST";

export const ADD_DIRECTOR_REQUEST = "ADD_DIRECTOR_REQUEST";
export const ADD_DIRECTOR_RESPONSE = "ADD_DIRECTOR_RESPONSE";

export const EDIT_DIRECTOR_REQUEST = "EDIT_DIRECTOR_REQUEST";
export const EDIT_DIRECTOR_RESPONSE = "EDIT_DIRECTOR_RESPONSE";
